import { getPlatform } from "../../../../global/utils/platformDetector";
import GoogleLogo from "../../../assets/images/generico/GoogleLogo.png";
import AppleLogo from "../../../assets/images/generico/AppleLogo.png";
import SocialDiv from "../SocialDiv/SocialDiv";
import "./SocialDivContainer.css";

const SocialDivContainer = ({ onClickHandler, responseFacebook }) => {
  const deviceType = getPlatform();

  let config = localStorage.getItem("config");
  let opcGoogle = JSON.parse(config).opcLoginGoogle;
  let opcApple = JSON.parse(config).opcLoginApple;

  return (
    <div className="ptur-socialdiv">
      {opcGoogle && (
        <div className="ptur-socialDiv-googleLogin">
          <SocialDiv
            logo={GoogleLogo}
            altStr="Google logo"
            backgroundClr="bgc-white"
            onClickHandler={onClickHandler}
          />
        </div>
      )}

      {opcApple ? (
        deviceType === "android" ? (
          ""
        ) : (
          <div className="ptur-socialDiv-iosLogin" style={{ width: "78px" }}>
            <SocialDiv
              logo={AppleLogo}
              altStr="Apple logo"
              backgroundClr="bgc-black"
              onClickHandler={onClickHandler}
            />
          </div>
        )
      ) : (
        ""
      )}
    </div>
  );
};

export default SocialDivContainer;
